<template>
  <el-row class="warp">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }"><b>首页</b></el-breadcrumb-item>
        <el-breadcrumb-item>设备管理</el-breadcrumb-item>
        <el-breadcrumb-item>供应商设备品类</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>

    <el-col :span="24" class="warp-main">
      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-form :inline="true" :model="filters" ref="filtersForm">
          <el-form-item label="设备品类" prop="categoryId">
            <el-select v-model="filters.categoryId" clearable filterable placeholder="请选择">
              <el-option v-for="item in deviceCategoryDatas" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="供应商设备品类名称" prop="name">
            <el-input v-model="filters.name" placeholder="供应商设备品类名称"></el-input>
          </el-form-item>
          <el-form-item label="供应商设备品类型号" prop="type">
            <el-input v-model="filters.type" placeholder="供应商设备品类型号"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch">查询</el-button>
            <el-button type="primary" @click="resetForm('filtersForm')">重置</el-button>
            <el-button type="primary" @click="showAddDialog" v-has-permission="'device:supplier:category:add'">新增</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <!--列表-->
      <el-table :data="deviceTypePageDatas" highlight-current-row border style="width: 100%;">
        <el-table-column type="index" width="60" align="center" fixed="left"></el-table-column>
        <el-table-column prop="name" label="供应商设备品类名称" width="180" show-overflow-tooltip sortable></el-table-column>
        <el-table-column prop="type" label="供应商设备品类型号" width="180" show-overflow-tooltip sortable></el-table-column>
        <el-table-column prop="serialNumber" label="供应商设备品类编号" width="180" show-overflow-tooltip sortable></el-table-column>
        <el-table-column prop="supplierName" label="设备供应商" width="200" show-overflow-tooltip sortable></el-table-column>
        <el-table-column prop="categoryName" label="设备品类" width="120" show-overflow-tooltip sortable></el-table-column>
        <el-table-column prop="sort" label="排序" width="80" align="center" sortable></el-table-column>
        <el-table-column prop="remark" label="备注" width="200" show-overflow-tooltip sortable></el-table-column>
        <el-table-column prop="createDate" label="创建时间" width="155" sortable></el-table-column>
        <el-table-column prop="updateDate" label="更新时间" width="155" sortable></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="showEditDialog(scope.$index,scope.row)" v-has-permission="'device:supplier:category:update'">编辑</el-button>
            <el-button type="danger" size="mini" @click="remove(scope.$index,scope.row)" v-has-permission="'device:supplier:category:delete'">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--分页工具栏-->
      <el-col :span="24" class="toolbar">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[10, 20, 50, 100]"
          :page-size="10" background layout="total, sizes, prev, pager, next, jumper" :total="total" style="float:right;">
        </el-pagination>
      </el-col>

      <!--新增界面-->
      <el-dialog title="新增" :visible.sync="addFormVisible" :close-on-click-modal="false">
        <el-form :model="addForm" label-width="150px" :rules="formRules" ref="addForm">
          <el-row>
            <el-col :span="12">
              <el-form-item label="供应商设备品类名称" prop="name">
                <el-input v-model.trim="addForm.name" placeholder="请输入内容" maxlength="40" show-word-limit auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="供应商设备品类型号" prop="type">
                <el-input v-model.trim="addForm.type" placeholder="请输入内容" maxlength="30" show-word-limit auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="供应商设备品类编号" prop="serialNumber">
                <el-input v-model.trim="addForm.serialNumber" placeholder="请输入内容" maxlength="20" show-word-limit auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="设备供应商" prop="supplierId">
                <el-select  v-model="addForm.supplierId" placeholder="请选择设备供应商" style="width:303px;">
                  <el-option v-for='(item,index) in allSupplier' :key="index" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="设备品类" prop="categoryId">
                <el-select v-model="addForm.categoryId" clearable filterable placeholder="请选择设备品类">
                  <el-option v-for="item in deviceCategoryDatas" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="排序" prop="sort">
                <el-input v-model.number="addForm.sort" placeholder="请输入内容" maxlength="11" show-word-limit auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="18">
              <el-form-item label="备注" prop="remark">
                <el-input type="textarea" v-model="addForm.remark" :rows="5" placeholder="请输入内容" maxlength="100" show-word-limit auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="addFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="addSubmit" :loading="loading">提交</el-button>
        </div>
      </el-dialog>

      <el-dialog title="编辑" :visible.sync="editFormVisible" :close-on-click-modal="false">
        <el-form :model="editForm" label-width="150px" :rules="formRules" ref="editForm">
          <el-input v-model="editForm.id" type="hidden"></el-input>
          <el-row>
            <el-col :span="12">
              <el-form-item label="供应商设备品类名称" prop="name">
                <el-input v-model.trim="editForm.name" placeholder="请输入内容" maxlength="40" show-word-limit auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="供应商设备品类型号" prop="type">
                <el-input v-model.trim="editForm.type" placeholder="请输入内容" maxlength="30" show-word-limit auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="供应商设备品类编号" prop="serialNumber">
                <el-input v-model.trim="editForm.serialNumber" placeholder="请输入内容" maxlength="20" show-word-limit auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="设备供应商" prop="supplierId">
                <el-select  v-model="editForm.supplierId" placeholder="请选择设备供应商" style="width:323px;">
                  <el-option v-for='(item,index) in allSupplier' :key="index" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="设备品类" prop="categoryId">
                <el-select v-model="editForm.categoryId" clearable filterable placeholder="请选择设备品类">
                  <el-option v-for="item in deviceCategoryDatas" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="排序" prop="sort">
                <el-input v-model.number="editForm.sort" placeholder="请输入内容" maxlength="11" show-word-limit auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="18">
              <el-form-item label="备注" prop="remark">
                <el-input type="textarea" v-model="editForm.remark" :rows="5" placeholder="请输入内容" maxlength="100" show-word-limit auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="editFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="editSubmit" :loading="loading">提交</el-button>
        </div>
      </el-dialog>
    </el-col>
  </el-row>
</template>
<script>
import DEVICE_API from '../../api/api_device';
import Dict_API from '../../api/api_dict';

export default {
  data() {
    let that = this;
    var checkType = (rule, value, callback) => {
      if (!value || value === '') {
        callback(new Error('请输入供应商设备品类型号'));
        return;
      }
      var params = {
        type: value
      }
      if (that.editFormVisible) {
        params = Object.assign(params, {
          id: that.editForm.id
        });
      }
      DEVICE_API.checkDeviceSupplierCategoryType(params)
      .then(
        function(result) {
          if (result && result.code == 200 
            && result.data && result.data === true) {
              callback(new Error('供应商设备品类型号重复'));
              return;
          }
          callback();
        },
        function(error) {
          that.$message.error({
            showClose: true,
            message: error.toString(),
            duration: 2000
          });
          callback();
        }
      )
      .catch(function(error){
        that.$message.error({
          showClose: true,
          message: '请求出现异常',
          duration: 2000
        });
        callback();
      });
    };
    // 排序字段校验方法
    var checkSort = (rule, value, callback) => {
      if (value) {
        setTimeout(() => {
          if (!Number.isInteger(value)) {
            callback(new Error('请输入数字值'));
          } else {
            if (value <= 0) {
              callback(new Error('输入数字必须大于等于0'));
            } else {
              callback();
            }
          }
        }, 1000);
      }
      // 清空排序字段时
      callback();
    };
    return {
      loading: false,
      filters: {},
      allSupplier:[],
      deviceCategoryDatas: [],

      // 分页参数
      total: 0,
      page: 1,
      limit: 10,
      deviceTypePageDatas: [],

      // 新增/编辑相关数据
      addFormVisible: false,//新增界面是否显示
      editFormVisible: false,//编辑界面是否显示
      addForm: {},
      editForm: {},
      formRules: {
        supplierId:[{required: true, message: '请选择设备供应商', trigger: ['blur','change']}],
        serialNumber:[{required: true, message: '请输入供应商设备品类编号', trigger: ['blur','change']}],
        name: [
          {required: true, message: '请输入供应商设备品类名称', trigger: ['blur','change']}
        ],
        type: [
          {required: true, validator: checkType, trigger: ['blur','change']}
        ],
        categoryId: [
          {required: true, message: '请选择设备品类', trigger: ['blur','change']}
        ],
        sort: [
          {validator: checkSort, trigger: ['blur','change']}
        ]
      }
    }
  },
  methods: {
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.handleSearch();
    },
    initDeviceCategory: function() {
      let that = this;
      DEVICE_API.deviceCategoryCombox()
      .then(
        function(result) {
          if (result && result.code == 200) {
            that.deviceCategoryDatas = result.data;
          }
        },
        function(error) {
          that.$message.error({
            showClose: true,
            message: error.toString(),
            duration: 2000
          });
        }
      )
      .catch(function(error){
        that.$message.error({
          showClose: true,
          message: '请求出现异常',
          duration: 2000
        });
      });
    },
    supplierSelect:function(){
      let that = this;
      DEVICE_API.allSupplier({})
      .then(
          function(result) {
            console.log(result);
            if (result && result.code == 200) {
              that.allSupplier= result.data;
            }
          },
          function(error) {
            that.$message.error({
              showClose: true,
              message: error.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error){
          that.$message.error({
            showClose: true,
            message: '请求出现异常',
            duration: 2000
          });
        });
    },
    search() {
      let that = this;
      let params = Object.assign({
        page: that.page,
        limit: that.limit,
      }, that.filters);
      DEVICE_API.deviceSupplierCategoryPageList(params)
      .then(
        function(result){
          if (result && result.code == 200) {
            that.total = result.data.total;
            that.deviceTypePageDatas = result.data.records;
          }
        },
        function(error){
          that.$message.error({
            showClose: true,
            message: error.toString(),
            duration: 2000
          });
        }
      )
      .catch(function(error){
        that.$message.error({
          showClose: true,
          message: '请求出现异常',
          duration: 2000
        });
      });
    },
    handleSearch() {
      this.total = 0;
      this.page = 1;
      this.search();
    },
    handleSizeChange(val) {
      this.limit = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.search();
    },
    showAddDialog: function () {
      this.addFormVisible = true;
    },
    //新增
    addSubmit: function () {
      let that = this;
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          that.loading = true;
          let params = Object.assign({}, this.addForm);
          DEVICE_API.saveDeviceSupplierCategory(params)
          .then(
            function(result){
              that.loading = false;
              if (result && result.code == 200 
                && result.data && result.data === true) {
                that.$message.success({
                  showClose: true,
                  message: '新增成功!',
                  duration: 2000
                });
                that.$refs['addForm'].resetFields();
                that.addFormVisible = false;
                that.handleSearch();
              } else {
                that.$message.error({
                  showClose: true,
                  message: '新增失败!',
                  duration: 2000
                });
              }
            },
            function(error){
              that.loading = false;
              that.$message.error({
                showClose: true,
                message: error.toString(),
                duration: 2000
              });
            }
          )
          .catch(function(error){
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: '请求出现异常!',
              duration: 2000
            });
          });
        }
      });
    },
    //显示编辑界面
    showEditDialog: function (index, row) {
      this.editFormVisible = true;
      //避免源对象row被修改
      var newRow = JSON.parse(JSON.stringify(row));
      this.editForm = Object.assign({}, newRow);
    },
    //编辑
    editSubmit: function () {
      let that = this;
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          that.loading = true;
          let params = Object.assign({}, this.editForm);
          DEVICE_API.updateDeviceSupplierCategory(params)
          .then(
            function(result){
              that.loading = false;
              if (result && result.code == 200 
                && result.data && result.data === true) {
                that.$message.success({
                  showClose: true,
                  message: '修改成功!',
                  duration: 2000
                });
                that.$refs['editForm'].resetFields();
                that.editFormVisible = false;
                that.handleSearch();
              } else {
                that.$message.error({
                  showClose: true,
                  message: '修改失败!',
                  duration: 2000
                });
              }
            },
            function(error){
              that.loading = false;
              that.$message.error({
                showClose: true,
                message: error.toString(),
                duration: 2000
              });
            }
          )
          .catch(function(error){
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: '请求出现异常!',
              duration: 2000
            });
          });
        }
      });
    },
    //删除
    remove: function (index, row) {
      let that = this;
      this.$confirm('确认删除该记录吗?', '提示', {type: 'warning'}).then(() => {
        that.loading = true;
        DEVICE_API.removeDeviceSupplierCategory(row.id)
        .then(
          function (result) {
            that.loading = false;
            if (result && result.code === 200 
              && result.data && result.data === true) {
              that.$message.success({
                showClose: true,
                message: '删除成功',
                duration: 1500
              });
              that.search();
            }
          }, 
          function (err) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
        })
        .catch(function (error) {
          that.loading = false;
          // console.log(error);
          that.$message.error({
            showClose: true,
            message: '请求出现异常',
            duration: 2000
          });
        });
      }).catch(() => {
      });
    }

  },
  mounted() {
    let that = this;
    let params = {};
    this.initDeviceCategory();
    that.supplierSelect();
    this.handleSearch();
  }
};
</script>


// WEBPACK FOOTER //
// deviceSupplierCategory.vue?04972c47